import React from "react";
const links = ["Customer Support", "Refund Policy", "Privacy Policy", "Terms and Conditions"];
export function Footer() {
  return <footer className="bg-navy-950 px-4 pb-32 pt-14 text-white/70 sm:pb-24" data-id="element-203" data-mp="20715qw8apju8">
      <div className="mx-auto max-w-4xl text-center" data-id="element-204" data-mp="2f3sbdn8kbrsa">
        <p className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-205" data-mp="2a5qsb2b4zsgt">Aesthetic Laser Clinical Blueprint™</p>
        <p className="mt-1 text-sm" data-id="element-206" data-mp="1mfmnwsq4joor">An Educational Reference Collection by Michael Carter.</p>

        <div className="mt-8 rounded-2xl bg-white/5 p-5 text-left text-xs leading-relaxed ring-1 ring-white/10 sm:p-6 sm:text-sm" data-id="element-207" data-mp="1hhbbqbccx23d">
          <p className="font-bold uppercase tracking-wide text-white" data-id="element-208" data-mp="1w6r3nunmjdkn">Important educational disclaimer</p>
          <p className="mt-2" data-id="element-209" data-mp="1reh89z3qplaz">
            AESTHETIC LASER CLINICAL BLUEPRINT™ is an educational reference collection intended for appropriately
            qualified professionals and eligible learners. It does not confer professional qualifications,
            authorization to perform clinical procedures, or certification in any clinical specialty.
          </p>
          <p className="mt-2" data-id="element-210" data-mp="1ij5mxonw1bds">
            The materials do not replace formal education, supervised practical training, individualized patient
            assessment, professional judgment, device-specific instructions, current clinical guidelines, or emergency
            protocols. Clinical decisions must be made by qualified practitioners in accordance with applicable laws,
            regulations, current evidence, manufacturer instructions, and individual patient circumstances.
          </p>
          <p className="mt-2" data-id="element-211" data-mp="14jmu033ne6m2">
            All templates and educational resources must be reviewed and adapted to the practitioner’s professional
            scope and applicable local requirements.
          </p>
        </div>

        <nav aria-label="Legal" className="mt-8" data-id="element-212" data-mp="2fyjkzije75w2">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-213" data-mp="2kxw5vxqpe2w0">
            {links.map(l => <li key={l} data-id="element-214" data-mp="1v9h8jzxoblnm">
                <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-215" data-mp="1v8pif4muig4q">
                  {l}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-6 text-xs text-white/50" data-id="element-216" data-mp="257542s33sx6u">© 2026 AESTHETIC LASER CLINICAL BLUEPRINT™. All rights reserved.</p>
      </div>
    </footer>;
}